import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { timeout } from 'rxjs/operators';

// Bounds how long the login screen will spin before surfacing an error if the API never responds.
const REQUEST_TIMEOUT_MS = 20000;

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private readonly apiBaseUrl = (environment.apiUrl || '').replace(/\/+$/, '');

  constructor(private httpClient: HttpClient) {

  }

  generateOTP(email: string) {
    return this.httpClient.get<any>(`${this.apiBaseUrl}/generateOTP/${email}`).pipe(timeout(REQUEST_TIMEOUT_MS));
  }

  validateOTP(email: string, otp: number) {
    return this.httpClient.get<any>(`${this.apiBaseUrl}/validateOTP/${email}/${otp}`).pipe(timeout(REQUEST_TIMEOUT_MS));
  }
}
